/**
 * Contentful Image API optimization parameters
 * Docs: https://www.contentful.com/developers/docs/references/images-api/
 * 
 * @param {string} url - Original Contentful image URL
 * @param {object} options - Optimization options
 * @param {number} options.width - Max width (default: 1200)
 * @param {number} options.quality - Quality 1-100 (default: 80)
 * @param {string} options.format - Format: webp, jpg, png (default: webp)
 * @param {string} options.fit - Fit mode: pad, fill, scale, crop, thumb (default: fill)
 */
function optimizeImageUrl(url, options = {}) {
    if (!url) return url;
    
    const {
        width = 1200,
        quality = 80,
        format = 'webp',
        fit = 'fill'
    } = options;
    
    // Ensure URL has protocol
    const fullUrl = url.startsWith('//') ? `https:${url}` : url;
    
    // Add Contentful Image API parameters
    const params = new URLSearchParams({
        w: width,
        q: quality,
        fm: format,
        fit: fit
    });
    
    return `${fullUrl}?${params.toString()}`;
}

function getImageUrl(content, options = {}){
    const { image } = content;
    const { file } = image.fields;
    
    return optimizeImageUrl(file.url, options);
}

function getImageUrlByName(images, name, options = {}){
    const content = images.find(img => img.id == name);
    if (!content) return null;
    return getImageUrl(content, options);
}


function getImageUrls(content, options = {}){
    const { images } = content;
    let imageUrls = [];
    for (let i = 0; i < images.length; i++) {
        const { file } = images[i];
        imageUrls.push(optimizeImageUrl(file.url, options));
    }

    return imageUrls;
}

/**
 * Get responsive image srcset for different screen sizes
 */
function getResponsiveImageUrl(url) {
    if (!url) return { src: url, srcSet: '' };
    
    const fullUrl = url.startsWith('//') ? `https:${url}` : url;
    
    const sizes = [400, 800, 1200, 1600];
    const srcSet = sizes
        .map(w => `${fullUrl}?w=${w}&q=80&fm=webp ${w}w`)
        .join(', ');
    
    return {
        src: `${fullUrl}?w=1200&q=80&fm=webp`,
        srcSet
    };
}

function sortBy(array, key) {
    return array.sort((a, b) => {
      if (parseInt(a[key]) < parseInt(b[key])) {
        return -1;
      }
      if (parseInt(a[key]) > parseInt(b[key])) {
        return 1;
      }
      return 0;
    });
  }

export { getImageUrl, getImageUrlByName, getResponsiveImageUrl, optimizeImageUrl, sortBy }
